import React from 'react';

// Facts read back as small capitals labels over their values, two to a row, as in the body of a HeadedCard. values
// are { label, value, note, isWide }: the note is a muted line under the value, and a wide fact takes the whole row.
// An empty or blank value shows as a muted "Not set", as on DefinitionCard.
export default function LabeledValues({ values = [] }) {
  return (
    <div className='lvals'>
      {values.map((item) => {
        const isEmpty =
          item.value === null ||
          item.value === undefined ||
          (typeof item.value === 'string' && item.value.trim() === '');
        return (
          <div
            key={item.label}
            className={item.isWide ? 'lvals-item wide' : 'lvals-item'}
          >
            <span className='lvals-label'>{item.label}</span>
            <b className={isEmpty ? 'lvals-value muted' : 'lvals-value'}>{isEmpty ? 'Not set' : item.value}</b>
            {item.note && <span className='lvals-note'>{item.note}</span>}
          </div>
        );
      })}
    </div>
  );
}
